module.exports = __webpack_public_path__ + "img/copy-colored.d0f5333f.svg";